import { render, staticRenderFns } from "./simOpenXcp.vue?vue&type=template&id=c8a427a8&scoped=true&"
import script from "./simOpenXcp.vue?vue&type=script&lang=js&"
export * from "./simOpenXcp.vue?vue&type=script&lang=js&"
import style0 from "./simOpenXcp.vue?vue&type=style&index=0&id=c8a427a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a427a8",
  null
  
)

export default component.exports